import Icon, { type IconProps } from "@/v2-ui/icon"
import Tooltip, {
  type TooltipProps,
  type TooltipContentProps,
} from "@/v2-ui/tooltip"

export type TooltipIconProps = TooltipProps & {
  iconSrc: IconProps["src"]
  iconSize?: IconProps["size"]
  iconClassName?: IconProps["className"]
  content?: TooltipContentProps["children"]
  contentSide?: TooltipContentProps["side"]
  contentClassName?: TooltipContentProps["className"]
}

function TooltipIcon(props: TooltipIconProps) {
  const {
    iconSrc,
    iconSize,
    iconClassName,
    content,
    contentSide,
    contentClassName,
    ...tooltipProps
  } = props
  return (
    <Tooltip {...tooltipProps}>
      <Tooltip.Trigger asChild>
        <Icon src={iconSrc} size={iconSize} className={iconClassName} />
      </Tooltip.Trigger>
      <Tooltip.Content side={contentSide} className={contentClassName}>
        {content}
      </Tooltip.Content>
    </Tooltip>
  )
}

export default TooltipIcon
